var map = {
	"./ic_add.svg": 1343,
	"./ic_back.svg": 2159,
	"./ic_forward.svg": 9417,
	"./icons/ic_arrow_right.svg": 2223,
	"./icons/ic_back.svg": 9676,
	"./icons/ic_burger_slim.svg": 1810,
	"./icons/ic_chevron_right.svg": 6757,
	"./icons/ic_forward.svg": 8648,
	"./icons/ic_instagram_footer.svg": 7371,
	"./icons/ic_mail.svg": 3004,
	"./icons/ic_medienh_user.svg": 7273,
	"./icons/ic_message.svg": 1654,
	"./icons/ic_message_footer.svg": 5868,
	"./icons/ic_play_circle.svg": 7702,
	"./icons/ic_spieler.svg": 1743,
	"./icons/ic_tiktok_footer.svg": 467,
	"./icons/ic_verein.svg": 9248,
	"./icons/ic_whatsapp.svg": 8655,
	"./icons/ic_whatsapp_footer.svg": 7779,
	"./icons/social/logo_facebook.svg": 7462,
	"./icons/social/logo_instagram.svg": 9842,
	"./icons/social/logo_linkedin.svg": 3812,
	"./icons/social/logo_tiktok.svg": 4308,
	"./icons/social/logo_twitter.svg": 7891,
	"./icons/social/logo_whatsapp.svg": 7028,
	"./icons/social/logo_x.svg": 6086
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5756;